declare module '@mui/material/styles' {
  interface TypographyVariants {
    bglTitle1 : React.CSSProperties
    bglTitle2 : React.CSSProperties
    bglTitle3 : React.CSSProperties
    bglTitle4 : React.CSSProperties
    bglSubtitle1 : React.CSSProperties
    bglSubtitle2 : React.CSSProperties
    bglSubtitle3 : React.CSSProperties
    bglSubtitle4 : React.CSSProperties
    bglBody1 : React.CSSProperties
    bglBody2 : React.CSSProperties
    bglBody3 : React.CSSProperties
    bglBody4 : React.CSSProperties
    bglCaption1 : React.CSSProperties
    bglCaption2 : React.CSSProperties
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    bglTitle1 ?: React.CSSProperties
    bglTitle2 ?: React.CSSProperties
    bglTitle3 ?: React.CSSProperties
    bglTitle4 ?: React.CSSProperties
    bglSubtitle1 ?: React.CSSProperties
    bglSubtitle2 ?: React.CSSProperties
    bglSubtitle3 ?: React.CSSProperties
    bglSubtitle4 ?: React.CSSProperties
    bglBody1 ?: React.CSSProperties
    bglBody2 ?: React.CSSProperties
    bglBody3 ?: React.CSSProperties
    bglBody4 ?: React.CSSProperties
    bglCaption1 ?: React.CSSProperties
    bglCaption2 ?: React.CSSProperties
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    bglTitle1 : true
    bglTitle2 : true
    bglTitle3 : true
    bglTitle4 : true
    bglSubtitle1 : true
    bglSubtitle2 : true
    bglSubtitle3 : true
    bglSubtitle4 : true
    bglBody1 : true
    bglBody2 : true
    bglBody3 : true
    bglBody4 : true
    bglCaption1 : true
    bglCaption2 : true
  }
}

export const BIDGELY_TYPOGRAPHY = {
  bglTitle1 : {
    fontSize : "42px",
    fontWeight : 700,
    lineHeight : "58px"
  },
  bglTitle2 : {
    fontSize : "32px",
    fontWeight : 700,
    lineHeight : "40px"
  },
  bglTitle3 : {
    fontSize : "24px",
    fontWeight : 700,
    lineHeight : "36px"
  },
  bglTitle4 : {
    fontSize : "22px",
    fontWeight : 700,
    lineHeight : "36px"
  },
  bglSubtitle1 : {
    fontSize : "20px",
    fontWeight : 500,
    lineHeight : "30px"
  },
  bglSubtitle2 : {
    fontSize : "18px",
    fontWeight : 400,
    lineHeight : "28px"
  },
  bglSubtitle3 : {
    fontSize : "16px",
    fontWeight : 500,
    lineHeight : "28px"
  },
  bglSubtitle4 : {
    fontSize : "18px",
    fontWeight : 500,
    lineHeight : "24px"
  },
  bglBody1 : {
    fontSize : "16px",
    fontWeight : 400,
    lineHeight : "24px"
  },
  bglBody2 : {
    fontSize : "14px",
    fontWeight : 400,
    lineHeight : "22px"
  },
  bglBody3 : {
    fontSize : "14px",
    fontWeight : 700,
    lineHeight : "22px"
  },
  bglBody4 : {
    fontSize : "14px",
    fontWeight : 500,
    lineHeight : "16px"
  },
  bglCaption1 : {
    fontSize : "12px",
    fontWeight : 400,
    lineHeight : "18px",
  },
  bglCaption2 : {
    fontSize : "12px",
    fontWeight : 600,
    lineHeight : "18px",
  }
}